import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { Sow } from "./@types";

const fetchGetSOWsByIdSowAdmin = async (
  fieldglassId: string
): Promise<any> => {
  const sows = await apiInputService.get(
    `/frontend/sow/operative/admin/${fieldglassId}`
  );
  const { data } = sows;

  return data;
};

export const useGetSOWsByIdSowAdminQuery = (
  params?: string,
  options?: any
) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["sowAdmById", subscription?.subscriptionId, params],
    () => fetchGetSOWsByIdSowAdmin(params),
    {
      ...options,
      keepPreviousData: true,
    }
  );
};
